module.exports = __webpack_public_path__ + "static/media/devide.6782b9a0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/svg/devide.svg
// module id = 1410
// module chunks = 0